// RouteRequest.jsx
import { useEffect } from 'react';

function RouteRequest({ from, to, onRouteReceived, onRouteLoading, onRouteError }) {
    useEffect(() => {
        if (!from || !to) return;

        // Говорим родителю, что началась загрузка
        onRouteLoading?.(true);

        fetch('/api/route', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ from, to })
        })
            .then((res) => {
                if (!res.ok) {
                    return res.json().then(errData => {
                        throw new Error(errData.error || 'Failed to fetch route');
                    });
                }
                return res.json();
            })
            .then((data) => {
                // Успешно
                onRouteLoading?.(false);
                onRouteReceived(data);
            })
            .catch((err) => {
                // Ошибка
                onRouteLoading?.(false);
                onRouteError?.(err.message);
            });
    }, [from, to, onRouteLoading, onRouteError, onRouteReceived]);

    // Ничего не рендерим, UI берёт на себя родитель
    return null;
}

export default RouteRequest;